<template>
    <div v-html="$route.params.gmoPage"></div>
</template>

<script>
export default {
}
</script>

<style></style>
